import { client } from './client'
import type { ClaudeApiKeyStatus, CopilotApiKeyStatus, TenantTitanSettings } from '@/types'

export const tenantSettingsApi = {
  getClaudeApiKey: () =>
    client.get<ClaudeApiKeyStatus>('/tenants/me/claude-api-key').then(r => r.data),

  saveClaudeApiKey: (apiKey: string) =>
    client.put('/tenants/me/claude-api-key', { apiKey }),

  deleteClaudeApiKey: () =>
    client.delete('/tenants/me/claude-api-key'),

  getCopilotApiKey: () =>
    client.get<CopilotApiKeyStatus>('/tenants/me/copilot-api-key').then(r => r.data),

  saveCopilotApiKey: (apiKey: string) =>
    client.put('/tenants/me/copilot-api-key', { apiKey }),

  deleteCopilotApiKey: () =>
    client.delete('/tenants/me/copilot-api-key'),

  getTitanSettings: () =>
    client.get<TenantTitanSettings>('/tenants/me/titan-settings').then(r => r.data),

  saveTitanSettings: (endpoint: string, caCertificate: string | null) =>
    client.put('/tenants/me/titan-settings', { endpoint, caCertificate }),

  deleteTitanSettings: () =>
    client.delete('/tenants/me/titan-settings'),
}
